import React, { Component } from "react";
import {
  profile, alert, float, toFixed, GET, POST, PUT, loading, Swal,
  Navbar, Select, BtnIcon, total, format_date, required, Modal,
} from "../../components/CustomComponent.js";
import Footer from "../../components/Footer.js";
import LOGOLARGE from "../../assets/images/logo512.png";
import PP from "../../assets/images/promptpay.png";
import TH_PROVINCE from "../../assets/files/th_province.json";
import html2canvas from "html2canvas";
import { PROCESS_TYPE } from "../../config/process-type.js";
import Dropdown from "react-bootstrap/Dropdown";
import "bootstrap/dist/css/bootstrap.min.css";

// 1. นำ Constants และ Data ที่ไม่มีการเปลี่ยนแปลงออกมาไว้ข้างนอก Component เพื่อลด Memory Allocation ซ้ำซ้อน
const TRANSPORT_RATES = { เรือ: 30.5, รถ: 28, เครื่องบิน: 80 };
const FEE_MAP = new Map([
  [1480, 113], [5800, 549], [9500, 500], [18168, 1000], [18300, 1084],
  [19500, 837], [20500, 837], [37000, 1100], [49300, 600], [48500, 1500],
  [93500, 1500], [98500, 1500], [147500, 2500], [148000, 2000], [149500, 500],
  [165666.67, 1000], [197000, 3000], [1383, 113], [5421, 549], [8878.5, 500],
  [16979, 1000], [17103, 1084], [18224, 837], [19159.3, 837], [34579, 1100],
  [46075, 600], [45327, 1500], [87383, 1500], [92056, 1500], [138318, 2000],
  [184112, 3000], [137850.50, 2500], [154828.67, 1000], [138317.75, 2000], [139719.63, 500]
]);

export default class DepositsWithdrawals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      remark: "",
      date: new Date(),
      transport: "เรือ",
      transport_price: 0,
      vat: 0,
      addresses: [],
      selectedAddressId: "",
      addressLoading: false,
      addressSubmitting: false,
      showAddAddressForm: false,
      newAddress: this.getDefaultNewAddress(),
      realtotal: 0,
      subtotal: 0,
    };
  }

  async componentDidMount() {
    loading(false);
    const cart = JSON.parse(localStorage.getItem("cart") || "[]");
    this.setState({ data: cart.map((e) => ({ ...e, selected: false })) }, async () => {
      this.calTransport();
      await this.loadCustomerAddresses();
    });
  }

  getDefaultNewAddress = () => ({
    uid: "",
    contact_name: profile?.full_name || "",
    contact_phone: profile?.phone || "",
    contact_email: profile?.email || "",
    address: "", sub_district: "", district: "", province: "", zipcode: "",
    country: "Thailand", is_default: false, remark: "", is_active: true,
  });

  hasCompleteDeliveryInfo = (addr) => addr && 
    ['contact_name', 'contact_phone', 'address', 'sub_district', 'district', 'province', 'zipcode']
    .every(key => `${addr[key] || ""}`.trim());

  loadCustomerAddresses = async () => {
    const customerUid = profile?.customer?.uid || process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "";
    if (!customerUid) return;

    this.setState({ addressLoading: true });
    const result = await GET("v1/public/market/customer-address", { uid: customerUid });

    if (result?.status) {
      const addresses = Array.isArray(result?.data) ? result.data : [];
      const selectedAddressId = localStorage.getItem("selected_shipping_address_id") || addresses.find((item) => item.is_default)?.uid || addresses[0]?.uid || "";
      localStorage.setItem("selected_shipping_address_id", selectedAddressId);
      this.setState({ addresses, selectedAddressId, addressLoading: false });
    } else {
      localStorage.clear();
      alert("/", "warning", "แจ้งเตือน", "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง");
    }
  };

  syncAddresses = async (addresses, selectedAddressId) => {
    const customerUid = profile?.customer?.uid || process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "";
    if (!customerUid) return alert("", "warning", "แจ้งเตือน", "ไม่พบข้อมูลลูกค้า"), false;

    this.setState({ addressSubmitting: true });
    loading(true);
    
    const result = await PUT(`v1/public/market/customer/${customerUid}`, {
      uid: customerUid,
      address_list: addresses.map(item => ({ ...item, country: item.country || "Thailand" })),
    });
    
    loading(false);
    this.setState({ addressSubmitting: false });

    if (!result?.status) return false;

    localStorage.setItem("selected_shipping_address_id", selectedAddressId || "");
    await this.loadCustomerAddresses();
    if (selectedAddressId) this.setState({ selectedAddressId });
    return true;
  };

  updateAddressState = (updates) => this.setState(prev => ({ newAddress: { ...prev.newAddress, ...updates } }));

  addNewAddress = async () => {
    const { addresses, newAddress, selectedAddressId } = this.state;
    const requiredFields = { contact_name: "ชื่อผู้รับ", contact_phone: "เบอร์โทร", address: "ที่อยู่", province: "จังหวัด", district: "เขต/อำเภอ", sub_district: "แขวง/ตำบล" };
    
    for (let key in requiredFields) {
      if (!newAddress[key].trim()) return alert("", "warning", "แจ้งเตือน", `กรุณากรอก${requiredFields[key]}`);
    }

    loading(true);
    const createdAddress = { ...newAddress, is_default: addresses.length === 0 };
    const nextAddresses = [...addresses, createdAddress].map((item, index, arr) => ({
      ...item, is_default: createdAddress.is_default ? index === arr.length - 1 : item.is_default
    }));

    if (await this.syncAddresses(nextAddresses, selectedAddressId)) {
      this.setState({ showAddAddressForm: false, newAddress: this.getDefaultNewAddress() });
    }
    loading(false);
  };

  manageAddress = async (id, action) => {
    const { addresses, selectedAddressId } = this.state;
    if (action === 'delete') {
      if (addresses.length <= 1) return alert("", "warning", "แจ้งเตือน", "ต้องมีที่อยู่จัดส่งอย่างน้อย 1 รายการ");
      if (!await alert("", "warning", "ยืนยันการลบ", "ต้องการลบที่อยู่นี้หรือไม่?", "ลบ", "ยกเลิก")) return;
    }

    const nextAddresses = addresses.map(item => {
      if (action === 'default') return { ...item, is_default: item.uid === id };
      if (action === 'delete') return item.uid === id ? { ...item, is_active: false, is_default: false } : item;
      return item;
    });

    const activeAddresses = nextAddresses.filter(i => i.is_active !== false);
    if (action === 'delete' && !activeAddresses.some(i => i.is_default) && activeAddresses[0]) {
      activeAddresses[0].is_default = true;
    }

    const nextSelectedId = action === 'delete' ? (activeAddresses.some(i => i.uid === selectedAddressId) ? selectedAddressId : activeAddresses[0]?.uid || "") : id;
    
    await this.syncAddresses(nextAddresses, nextSelectedId);
  };

  Submit = async () => {
    if (!await alert("", "info", "ยืนยัน", "ยืนยันการสั่งซื้อสินค้านี้หรือไม่?", "ยืนยัน", "ยกเลิก")) return;
    
    const { data, remark, addresses, selectedAddressId, subtotal, transport_price, vat } = this.state;
    const selectedAddress = addresses.find((item) => item.uid === selectedAddressId);
    
    if (!selectedAddress) return alert("", "warning", "แจ้งเตือน", "กรุณาเลือกที่อยู่จัดส่ง");
    if (!this.hasCompleteDeliveryInfo(selectedAddress)) return alert("", "warning", "แจ้งเตือน", "กรุณากรอกข้อมูลจัดส่งให้ครบ");

    loading(true);
    const amount = subtotal + transport_price + vat;
    const currentProfile = profile;
    
    const body = {
      customer_id: currentProfile?.customer?.uid || process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "",
      amount, ref_no: Date.now().toString(),
      client_id: process.env.REACT_APP_CLIENT_ID || "",
      client_secret: process.env.REACT_APP_CLIENT_SECRET || "",
      client_ref_id: process.env.REACT_APP_CLIENT_REF_ID || "",
      "x-apigw-api-id": process.env.REACT_APP_X_APIGW_API_ID || "",
      currency: "THB",
      order: {
        total_quantity: data.length, total_price: amount.toFixed(2), fee: transport_price.toFixed(2),
        order_status: "pending", remark, shipping_address: selectedAddress,
        // process_type = ระบบหน้าบ้านที่สร้างรายการ (รายชื่อทั้งหมดอยู่ที่
        // PaymentBroker-Frontend/src/components/process-type.js)
        process_type: PROCESS_TYPE,
        order_items: data.map((e) => ({ ...e, total_price: (e.quantity * e.price).toFixed(2), remark: "", price: Number(e.price).toFixed(2), process_type: PROCESS_TYPE })),
      },
    };

    if (currentProfile?.['company-uid'] || data['company-uid']) {
        body['company-uid'] = currentProfile?.['company-uid'] || data['company-uid'];
    }

    const result = await POST(`transactions/deposits/partner`, body);
    
    if (result?.data?.status?.message === "Success") {
      loading(false);
      const transactionId = result?.data?.data?.transaction_id;
      if (transactionId) {
        await PUT(`v1/market/orders/delivery/transaction/${transactionId}`, { ...selectedAddress, delivery_remark: selectedAddress.remark || "" });
      }
      this.showQRCode(result.data.data.base64, amount);
    } else {
      loading(false);
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
    }
  };

  showQRCode = (base64, amount) => {
    let timerInterval, timeLeft = 600; // 10 minutes
    Swal.fire({
      showCloseButton: true, allowOutsideClick: false, allowEscapeKey: false,
      confirmButtonText: "ดาวน์โหลด QRcode",
      customClass: { popup: "bg-orange rounded-5", closeButton: "text-light", confirmButton: "btn btn-light text-orange" },
      html: `
        <div class="bg-orange p-3" id="qrcode">
          <div class="rounded-4 bg-white overflow-hidden">
            <div class="pt-4 pb-3">
              <h4 class="text-center">ราคารวมทั้งหมด : ${toFixed(amount)} บาท</h4>
              <div class="text-secondary">ห้ามปิดหน้านี้จนกว่าจะดำเนินการชำระสำเร็จ</div>
              <div class="mt-3 p-2 rounded-3" style="background:#fff5f0;border:1px solid #ffdecb;">
                <div class="text-dark small">QR Code จะหมดอายุในอีก</div>
                <div id="countdown-timer" class="h3 fw-bold text-danger mb-0">10:00</div>
              </div>
            </div>
            <div class="bg-white p-2 w-75 rounded-3 mx-auto my-3">
              <img src="${base64.replaceAll("_", "+")}" alt="QR code" class="img-fluid w-100"/>
            </div>
            <h4 class="fw-bold mb-4">ZENITH CARGO</h4>
          </div>
        </div>`,
      didOpen: () => {
        const timerDisplay = document.getElementById("countdown-timer");
        timerInterval = setInterval(() => {
          if (--timeLeft <= 0) return clearInterval(timerInterval), Swal.close();
          if (timerDisplay) timerDisplay.textContent = `${String(Math.floor(timeLeft / 60)).padStart(2, '0')}:${String(timeLeft % 60).padStart(2, '0')}`;
        }, 1000);
      },
      willClose: () => clearInterval(timerInterval),
      preConfirm: async () => {
        const canvas = await html2canvas(document.getElementById("qrcode"));
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png");
        link.download = `deposit_qr_code_${toFixed(amount)}.png`;
        link.click();
        return false; 
      }
    }).then(() => {
      localStorage.removeItem("cart");
      window.location.href = "/transaction";
    });
  };

  roundDecimalToNearest = (num) => {
    let baht = Math.floor(num), satang = Math.round((num - baht) * 100);
    let roundedSatang = Math.round(satang / 5) * 5;
    if (roundedSatang >= 100) { baht += 1; roundedSatang = 0; }
    return baht + roundedSatang / 100;
  };

  calTransport = () => {
    const { transport, data } = this.state;
    const rate = TRANSPORT_RATES[transport] || 0;
    
    let subtotal = 0, transport_fee = 0;
    
    data.forEach(e => {
      const price = Number(e.price), qty = Number(e.quantity);
      subtotal += qty * price;
      transport_fee += FEE_MAP.has(price) ? FEE_MAP.get(price) * qty : (qty * price) * (rate / 400);
    });

    const realtotal = subtotal;
    subtotal = this.roundDecimalToNearest(subtotal);
    let vat = Math.round(subtotal * 0.07);
    if ((subtotal + Math.ceil(transport_fee) + vat) === 599999.50) vat += 0.5;

    this.setState({ transport_price: Math.ceil(transport_fee), vat, subtotal, realtotal });
  };

  updateCartQty = (index, delta) => {
    const data = [...this.state.data];
    data[index].quantity = Math.max(1, data[index].quantity + delta);
    localStorage.setItem("cart", JSON.stringify(data));
    this.setState({ data }, this.calTransport);
  };

  render() {
    const { transport, transport_price, vat, date, data, remark, addresses, selectedAddressId, addressLoading, showAddAddressForm, newAddress, realtotal, subtotal } = this.state;
    
    // คำนวณ Options ของจังหวัด, อำเภอ, ตำบล แบบ On-the-fly แทนการสร้างฟังก์ชันแยก
    const provinces = TH_PROVINCE || [];
    const districts = provinces.find((p) => p.th === newAddress.province)?.district || [];
    const subDistricts = districts.find((d) => d.th === newAddress.district)?.sub_district || [];
    
    const mapToOptions = (arr) => arr.map(item => ({ value: item.th, label: item.th }));
    const selectedAddress = addresses.find((item) => item.uid === selectedAddressId);

    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="min-vh-100">
          {data.length > 0 ? (
            <div className="container my-4 px-3">
              <h2 className="fw-bold mb-4">ตะกร้าสินค้า</h2>
              <div className="row">
                <div className="col-12 col-lg-7 col-xl-8">
                  {data.map((item, index) => (
                    <div key={index} className="card rounded-4 mb-3 p-3">
                      <div className="d-flex justify-content-between align-items-end">
                        <div className="d-flex">
                          <img src={item.product_image || LOGOLARGE} alt="THUMBNAIL" className="wpx-100 hpx-100 bg-secondary-light rounded-4" style={{ objectFit: "cover" }} onError={(e) => e.currentTarget.src = LOGOLARGE} />
                          <div className="ps-3">
                            <div className="overflow-hidden" style={{ lineHeight: 1.2, height: 36 }}>{item.product_name}</div>
                            <div className="fw-bold text-orange mb-2">฿{toFixed(item.price)}</div>
                            <div className="d-flex align-items-center">
                              <button className="btn btn-dark btn-sm px-2" onClick={() => this.updateCartQty(index, -1)} disabled={item.quantity === 1}>-</button>
                              <div className="wpx-40 text-center">{item.quantity}</div>
                              <button className="btn btn-dark btn-sm px-2" onClick={() => this.updateCartQty(index, 1)}>+</button>
                            </div>
                          </div>
                        </div>
                        <BtnIcon type="delete" onClick={async () => {
                          if (await alert("", "warning", "ยืนยันการลบ", "ยืนยันการลบรายการนี้หรือไม่?", "ลบสินค้า", "ยกเลิก")) {
                            const _data = data.filter((_, i) => i !== index);
                            this.setState({ data: _data }, this.calTransport);
                            localStorage.setItem("cart", JSON.stringify(_data));
                          }
                        }} />
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="col-12 col-lg-5 col-xl-4">
                  <div className="p-3 bg-white rounded-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="fw-bold mb-0">ที่อยู่ในการจัดส่ง</div>
                      <div className="d-flex align-items-center">
                        <span className="badge text-bg-light">{addresses.length} รายการ</span>
                        <button className="btn bg-orange text-white rounded-4 ms-2" onClick={() => this.setState({ showAddAddressForm: true, newAddress: this.getDefaultNewAddress() })}>เพิ่มที่อยู่ใหม่</button>
                      </div>
                    </div>
                    
                    {addressLoading && <div className="bg-secondary-light rounded-4 p-3 mb-3 text-secondary">กำลังโหลดที่อยู่...</div>}
                    
                    <div className="mb-3">
                      {addresses.length > 0 ? addresses.map((item, index) => (
                        <div key={item.uid} className={`w-100 text-start border rounded-4 p-3 mb-2 ${selectedAddressId === item.uid ? "border-orange" : "border-secondary"}`}
                          style={{ boxShadow: selectedAddressId === item.uid ? "0 0 0 3px rgba(255, 140, 0, 0.38), 0 10px 20px rgba(255, 140, 0, 0.18)" : "none", cursor: "pointer", backgroundColor: selectedAddressId === item.uid ? '#fff8ed' : 'unset' }}
                          onClick={() => { localStorage.setItem("selected_shipping_address_id", item.uid); this.setState({ selectedAddressId: item.uid }); }}
                        >
                          <div className="d-flex justify-content-between align-items-start gap-2 flex-wrap mb-2">
                            <div>
                              <div className="fw-bold d-flex align-items-center gap-2 flex-wrap">
                                <span>{item.is_default ? "ที่อยู่หลัก" : `ที่อยู่จัดส่ง ${index + 1}`}</span>
                                {item.is_default && <span className="badge bg-orange text-white">ค่าเริ่มต้น</span>}
                                {selectedAddressId === item.uid && <span className="badge bg-dark text-white">กำลังใช้งาน</span>}
                              </div>
                              <div className="text-secondary small">{item.contact_name || "-"} | {item.contact_phone || "-"}</div>
                              {item.contact_email && <div className="text-secondary small">{item.contact_email}</div>}
                            </div>
                            <Dropdown>
                              <Dropdown.Toggle variant="gray" size="sm">จัดการ</Dropdown.Toggle>
                              <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                {!item.is_default && (
                                  <Dropdown.Item className="rounded-3 d-flex align-items-center px-2" onClick={(e) => { e.stopPropagation(); this.manageAddress(item.uid, 'default'); }}>
                                    <div className="fw-bold icon me-1 wpx-15 text-center text-12">{"\uf005"}</div> ตั้งเป็นที่อยู่หลัก
                                  </Dropdown.Item>
                                )}
                                <Dropdown.Item className="rounded-3 d-flex align-items-center px-2 text-danger" onClick={(e) => { e.stopPropagation(); this.manageAddress(item.uid, 'delete'); }}>
                                  <div className="fw-bold icon me-1 wpx-15 text-center text-12">{"\uf1f8"}</div> ลบ
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div className="small fw-bold mb-1">{item.address || "-"}</div>
                          <div className="text-secondary small">{[item.sub_district, item.district, item.province, item.zipcode, item.country].filter(Boolean).join(" ")}</div>
                          {item.remark && <div className="text-secondary small">หมายเหตุ: {item.remark}</div>}
                        </div>
                      )) : <div className="bg-secondary-light rounded-4 p-3 text-secondary">ยังไม่มีที่อยู่จัดส่ง</div>}
                    </div>

                    <div className="mb-2 fw-bold">หมายเหตุ</div>
                    <textarea rows={4} className="form-control mb-3" placeholder="หมายเหตุ..." onChange={(e) => this.setState({ remark: e.target.value })} value={remark} />
                    
                    <div className="mb-2 fw-bold">สรุปคำสั่งซื้อ</div>
                    {realtotal !== subtotal && (
                      <div className="d-flex mb-3"><div className="w-100">ปรับปรุงยอดเงิน</div><span className="fw-bold mx-3">{toFixed(realtotal - subtotal)}</span><span>บาท</span></div>
                    )}
                    <div className="d-flex mb-3"><div className="w-100">ราคาสินค้า</div><span className="fw-bold mx-3">{toFixed(total(data.map(e => ({ total: e.quantity * e.price })), "total"))}</span><span>บาท</span></div>
                    <div className="d-flex mb-3"><div className="w-100">ภาษีมูลค่าเพิ่ม</div><span className="fw-bold mx-3">{toFixed(vat)}</span><span>บาท</span></div>
                    <div className="d-flex mb-3"><div className="w-100">ค่าจัดส่ง</div><span className="fw-bold mx-3">{toFixed(transport_price)}</span><span>บาท</span></div>
                    
                    <hr />
                    <div className="d-flex align-items-center mb-3">
                      <div className="w-100">ราคารวม</div><h4 className="fw-bold mx-3 mb-0 text-orange">{toFixed(subtotal + transport_price + vat)}</h4><span>บาท</span>
                    </div>
                    <button className="btn bg-orange w-100 hpx-40" onClick={this.Submit} disabled={!this.hasCompleteDeliveryInfo(selectedAddress)}>ดำเนินการชำระเงิน</button>
                    <div className="text-center mt-3"><img alt="promptpay" src={PP} height={40} /></div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="p-5 text-center">
              <h1 className="fw-bold text-secondary icon text-72 mb-4">{"\uf290"}</h1>
              <h1 className="fw-bold">ตะกร้าว่างเปล่า</h1>
              <button className="btn bg-orange px-5 mt-3" onClick={() => window.location.href = "/main"}>ดูสินค้า</button>
            </div>
          )}
        </div>
        <Footer />

        <Modal show={showAddAddressForm} onHide={() => this.setState({ showAddAddressForm: false })}>
          <Modal.Header className="border-0" closeButton><h5 className="fw-bold mb-0">เพิ่มที่อยู่ใหม่</h5></Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-12 mb-3">
                <label className="form-label text-secondary mb-1">ชื่อผู้รับ{required}</label>
                <input type="text" className="form-control" value={newAddress.contact_name} onChange={(e) => this.updateAddressState({ contact_name: e.target.value })} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label text-secondary mb-1">เบอร์โทร{required}</label>
                <input type="text" className="form-control" maxLength={10} value={newAddress.contact_phone} onChange={(e) => float(e.target.value) && this.updateAddressState({ contact_phone: e.target.value })} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label text-secondary mb-1">ที่อยู่จัดส่ง{required}</label>
                <textarea rows={3} className="form-control" value={newAddress.address} onChange={(e) => this.updateAddressState({ address: e.target.value })} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label text-secondary mb-1">จังหวัด{required}</label>
                <Select className="form-control" options={mapToOptions(provinces)} value={newAddress.province} onChange={(val) => this.updateAddressState({ province: val, district: "", sub_district: "", zipcode: "" })} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label text-secondary mb-1">เขต/อำเภอ{required}</label>
                <Select className="form-control" options={mapToOptions(districts)} value={newAddress.district} disabled={!newAddress.province} onChange={(val) => this.updateAddressState({ district: val, sub_district: "", zipcode: "" })} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label text-secondary mb-1">แขวง/ตำบล{required}</label>
                <Select className="form-control" options={mapToOptions(subDistricts)} value={newAddress.sub_district} disabled={!newAddress.district} onChange={(val) => this.updateAddressState({ sub_district: val, zipcode: String(subDistricts.find(s => s.th === val)?.code || "") })} />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label text-secondary mb-1">รหัสไปรษณีย์</label>
                <input type="text" className="form-control" value={newAddress.zipcode} readOnly />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <button className="btn btn-dark px-5 me-1" onClick={this.addNewAddress}>submit</button>
            <button className="btn btn-outline-dark px-5 ms-1" onClick={() => this.setState({ showAddAddressForm: false })}>cancel</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}